<template>
  <v-content>
    <v-row no-gutters>
      <v-col cols="12">
        <v-flex class="pb-2 ml-0">
          <v-alert dense color="primary" class="text-left" text border="left"
            >QRCODE</v-alert
          >
        </v-flex>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" xl="6" lg="2" md="2" sm="4" xs="8">
        <v-text-field
          prepend-inner-icon="mdi-table-chair"
          v-model="config.qtde_mesa"
          filled
          v-mask="'###'"
          dense
          @blur="mudarValor('qtde_mesa', config.qtde_mesa)"
          @keyup.enter="mudarValor('qtde_mesa', config.qtde_mesa)"
          label="Quantidade de mesas"
          required
          persistent-hint
        ></v-text-field>
      </v-col>

      <v-col cols="12" xl="3" lg="3" md="2" sm="4" xs="8">
        <v-text-field
          label="Link Cardápio"
          append-icon="mdi-link"
          filled
          readonly
          v-model="link_cardapio"
          :append-icon="'mdi-content-copy'"
          @click:append="copyText"
        ></v-text-field>
        <a href="#" target="_self" id="linkDownload" download></a>
      </v-col>
      <v-col cols="12" xl="3" lg="2" md="2" sm="6" xs="1">
        <v-btn
          color="success"
          :loading="loadingbt"
          large
          @click="gerarQrcode()"
        >
          <v-icon>mdi-qrcode</v-icon>
          Gerar Qrcodes
        </v-btn>
      </v-col>
    </v-row>
  </v-content>
</template>

<script>
var moment = require("moment");
import { mask } from "vue-the-mask";
const auth = {
  headers: {
    Authorization: "bearer " + window.sessionStorage.getItem("token"),
  },
};

export default {
  directives: { mask },
  props: {
    source: String,
  },
  mounted() {
    //this.buscaNotas();
    // this.gerarQrcode();
    this.lista();

    this.linkCardapio();
  },

  data: (vm) => ({
    loadingbt: false,
    multiline: true,
    textSnack: "",
    snackbarSuccess: false,
    config: {
      qtde_mesa: "",
    },
    link_cardapio: "",
  }),

  methods: {
    copyText() {
      navigator.clipboard.writeText(this.link_cardapio);

      this.snackbarSuccess = true;
      this.textSucesso = "Link copiado";
    },
    linkCardapio() {
      axios.get(`/config/link_cardapio`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.link_cardapio = response.data.url;

          // console.log(response.data);
        }
      });
    },
    lista() {
      axios.get(`/config/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.config.pedido_minimo = response.data.pedido_minimo;
          this.config.taxa_gratis = response.data.taxa_gratis;
          this.config.tempo_entrega = response.data.tempo_entrega;
          this.config.hora_inicial = response.data.hora_inicial;
          this.config.hora_final = response.data.hora_final;
          this.config.retira_loja = response.data.retira_loja;
          this.config.url_loja = response.data.url_loja;
          this.config.url_logo = response.data.url_logo;
          this.config.manutencao = response.data.manutencao;
          this.config.aberto = response.data.aberto;
          this.config.dia_1 = response.data.dia1;
          this.config.dia_2 = response.data.dia2;
          this.config.dia_3 = response.data.dia3;
          this.config.dia_4 = response.data.dia4;
          this.config.dia_5 = response.data.dia5;
          this.config.dia_6 = response.data.dia6;
          this.config.dia_7 = response.data.dia7;
          this.dias_entrega = response.data.dias_semana;
          this.config.qtde_mesa = response.data.qtde_mesa;
          this.config.alerta_sonoro_pedido_recebido =
            response.data.alerta_sonoro_pedido_recebido;
          // console.log(response.data);
        }
      });
    },
    mudarValor(campo, valor) {
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      /*  if(campo =="tempo_entrega"){
        data:{tempo_entrega:valor}
      }*/
      var formData = new FormData();
      formData.append(campo, valor);
      axios
        .post(`/config`, formData, config)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaProdutosSgt();
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
            this.categoria.descricao = "";
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
    },
    gerarQrcode() {
      this.loadingbt = true;
      axios.get(`/config/qrcode`).then((response) => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbar = true;
          this.lista = [];
        } else {
          document.getElementById("linkDownload").href = response.data.url;
          document.getElementById("linkDownload").click();
        }
        this.loadingbt = false;
      });
    },
    async downloadItem({ url, label }) {
      const response = await axios.get(url, { responseType: "blob" });
      const blob = new Blob([response.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = label;
      link.click();
      URL.revokeObjectURL(link.href);
    },
  },
};
</script>
<style scoped>
.cancelada {
  color: red;
}
</style>
